import React from "react";
import Common_Banner from "../Common_Components/Common_Heading/Common_Banner/Common_Banner";
import Card_Section from "../Card_Section/Card_Section";
import RecruitmentProcess from "./Recruitment_Process/Recruitment_Process";
import ReadyToStart from "../Home/Ready_To_Start/Ready_To_Start";
import GlobalCareerCTA from "../Home/GlobalCareerCTA/GlobalCareerCTA";

function New_Services() {
  return (
    <>
      <Common_Banner
        image="/assets/images/services_page/banner.png"
        title="Our Services"
        subtitle="Industry-leading recruitment with unmatched expertise and proven success record"
      />
      <RecruitmentProcess />
      <Card_Section />



      {/* <ReadyToStart /> */}

      <GlobalCareerCTA />
    </>
  );
}

export default New_Services;
